interface FormHeaderProps {
    title: string;
    description?: string;
}

export const FormHeader = ({ title, description }: FormHeaderProps) => {
    return (
        <div
            className={`flex flex-col items-center pb-9 text-center ${description ? 'gap-7' : 'gap-0'}`}
        >
            <h1 className="text-2xl font-medium text-gray-900">{title}</h1>
            {description && (
                <p
                    className="mt-1 max-w-[22.1875rem] text-5.5 font-medium leading-normal text-gray-900"
                    dangerouslySetInnerHTML={{ __html: description }}
                />
            )}
        </div>
    );
};
